import React from 'react';
import { SecclProvider as SecclProviderUI } from '@seccl/ui';

import { useBranding } from '../context/branding.context';

export const SecclProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { getLogoUrl } = useBranding();

  return (
    <SecclProviderUI
      config={{
        logoPath: getLogoUrl('headerLogo') ?? '',
      }}
    >
      {children}
    </SecclProviderUI>
  );
};
